(function ($) {





// Variables
// -----------------------------------------------------------------------------

	/* global document, window, LazyLoad, jQuery, getComputedStyle, gsap,
	bodyScrollLock, ScrollTrigger, ResizeObserver, outerWidth */

	const documentBodyStyle = getComputedStyle(document.body);
	const lgBreakpoint = documentBodyStyle.getPropertyValue("--lg-breakpoint");

	const transition3 = 750;
	const transitionLong = 1200;
	const inviewDelay = 150;
	const ease = "easeInOutQuart";

	let previousWindowHeight = 0;
	let windowTop;
	let windowHeight;
	let triggers = [];
	let scrollbarWidth = 0;





// Init Lazy Load
// -----------------------------------------------------------------------------

	function initLazyLoad() {
		const lazyLoadInstance = new LazyLoad({ // eslint-disable-line no-unused-vars
			elements_selector: ".js-lazy",
		});
	}





// Set Variables in JS
// -----------------------------------------------------------------------------

	function setScrollbarWidthVariable() {
		scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
		document.documentElement.style.setProperty("--scrollbar", `${scrollbarWidth}px`);
	}

	function set100VHVariable() {
		windowHeight = window.innerHeight;
		const windowOuterHeight = window.outerHeight;
		if (windowOuterHeight !== previousWindowHeight) {
			previousWindowHeight = windowOuterHeight;
			document.documentElement.style.setProperty("--vh", `${windowHeight}px`);
		}
	}





// Toggle Menu
// -----------------------------------------------------------------------------

	function closeMenu() {
		$("html").removeClass("menu-is-open");
		setTimeout(function(){
			bodyScrollLock.clearAllBodyScrollLocks();
			$(".js-header").css("padding-right", "");
		}, transition3);
	}

	function toggleMenu() {
		$(".js-toggle-menu").click(function(event) {
			event.preventDefault();
			if ($("html").hasClass("menu-is-open")) {
				closeMenu();
			} else {
				$("html").addClass("menu-is-open");
				if (window.innerWidth - document.documentElement.clientWidth > 0) {
					$(".js-header").css("padding-right", `${scrollbarWidth}px`);
				}
				bodyScrollLock.disableBodyScroll($(".js-nav").get(0), {
					reserveScrollBarGap: true,
				});
			}
		});
	}




// Scroll to Hash
// -----------------------------------------------------------------------------

	function scrollToHash() {
		$(".js-hash-link").click(function(event){
			const duration = $(this).hasClass("js-hash-link--menu") ? 0 : transitionLong;
			event.preventDefault();
			const hash = $(this).attr("href");
			const scrollTo = $(hash).offset().top;
			$("html, body").animate({
				scrollTop: (scrollTo),
			}, duration, ease, function(){
				closeMenu();
			});
		})
	}





// Active Menu on Scroll
// -----------------------------------------------------------------------------

	function onScroll(){
		$('.js-dot-link').each(function () {
			const currLink = $(this);
			const refElement = $(currLink.attr("href"));
			const refElementTop = refElement.position().top;
			if (refElementTop <= windowTop && refElementTop + refElement.outerHeight() > windowTop) {
				$('.js-dot-link').removeClass("is-active");
				currLink.addClass("is-active");
			} else{
				currLink.removeClass("is-active");
			}
		});
	}





// Counter
// -----------------------------------------------------------------------------

	function counterAnimation(qSelector, start = 0, end, duration = 1000) {
		const target = qSelector;
		let startTimestamp = null;
		const step = (timestamp) => {
		if (!startTimestamp) startTimestamp = timestamp;
			const progress = Math.min((timestamp - startTimestamp) / duration, 1);
			target.text(Math.floor(progress * (end - start) + start));
			if (progress < 1) {
				window.requestAnimationFrame(step);
			}
		};
		window.requestAnimationFrame(step);
	};





// In View
// -----------------------------------------------------------------------------

	function addInView(loadingElement, loadingIndex) {
		if (loadingElement.hasClass("is-loading") || loadingElement.hasClass("is-loaded")) return;

		loadingElement.addClass("is-loading");
		setTimeout(() => {
			loadingElement.addClass("is-loaded");
			loadingElement.removeClass("is-loading");

			if (loadingElement.find(".js-counter").length) {
				const countingElement = loadingElement.find(".js-counter");
				countingElement.each(function(){
					counterAnimation($(this), $(this).data("start"), $(this).data("end"), transition3);
				});
			}

		}, inviewDelay * (loadingIndex));
	}

	function inView() {
		let loadItems = $(".js-inview:visible").not(".is-loaded");
		if (window.matchMedia(`(max-width: ${parseInt(lgBreakpoint, 10) - 1}px)`).matches) {
			loadItems = $(".js-inview:visible, .js-side-inview:visible, .js-image-inview:visible").not(".is-loaded");
		}
		let stoppedAt = 0;

		loadItems.each(function (loadItemIndex) {
			const loadItem = $(this);
			const loadItemTop = loadItem.offset().top;

			if (windowTop + (windowHeight * 0.95) > loadItemTop) {
				if (windowTop - windowHeight / 2 > loadItemTop) {
					loadItem.addClass("is-loaded");
					loadItem.removeClass("is-loading");
					if (loadItem.find(".js-counter").length) {
						const countingElement = loadItem.find(".js-counter");
						countingElement.each(function(){
							$(this).html($(this).data("end"));
						});
					}
					stoppedAt = loadItemIndex;
					return;
				}
				addInView(loadItem, loadItemIndex - stoppedAt);
			}
		});
	}





// Main Scroll
// -----------------------------------------------------------------------------

	function mainScroll() {
		if (window.matchMedia(`(min-width: ${lgBreakpoint})`).matches) {
			gsap.registerPlugin(ScrollTrigger);

			const boxes = gsap.utils.toArray('.js-wide-inside');

			boxes.forEach(box => {
				const tl = gsap.to(box, {
					xPercent: -100,
					x: () => (outerWidth - scrollbarWidth), // eslint-disable-line no-restricted-globals
					ease: "none",
					scrollTrigger: {
						trigger: $(box).parent(),
						start: "bottom bottom",
						end: () => `+=${$(box).outerWidth() - window.outerWidth}`,
						scrub: 0.1,
						pin: true,
						invalidateOnRefresh: true,
						anticipatePin: 1,
						toggleClass: 'is-active',
						pinType: "fixed",
					}
				});

				const imageOverlay = $(box).parent().find(".js-wide-background-overlay");
				const wideTitle = $(box).find(".js-wide-title");
				if (imageOverlay.length > 0) {
					gsap.to(imageOverlay, {
						opacity: 0.7,
						ease: "none",
						scrollTrigger: {
							trigger: wideTitle,
							containerAnimation: tl,
							invalidateOnRefresh: true,
							scrub: 0.1,
							start: "left left",
							end: () => `+=${$(wideTitle).outerWidth() / 2}`,
							toggleActions: "play none reverse reset",
						}
					});
				}

				const boxesInView = $(box).find(".js-side-inview").toArray();
				if (boxesInView.length > 0) {
					boxesInView.forEach(boxInView => {
						ScrollTrigger.create({
							trigger: boxInView,
							containerAnimation: tl,
							invalidateOnRefresh: true,
							start: "left 92%",
							onEnter: function(){
								addInView($(boxInView), 1);
							},
						})
					});
				}

				triggers.push(tl.scrollTrigger);
			});
		}
	}

	function updateMainScroll() {
		if (window.matchMedia(`(max-width: ${parseInt(lgBreakpoint, 10) - 1}px)`).matches && triggers.length > 0) {
			triggers.forEach(t => t.kill());
			triggers = [];
		} else if (window.matchMedia(`(min-width: ${lgBreakpoint})`).matches) {
			if (triggers.length === 0) {
				mainScroll();
			} else {
				ScrollTrigger.refresh();
			}
		}
	}





// Quote Background Slider
// -----------------------------------------------------------------------------

	function quoteSlider() {
		$('.js-quote-background').slick({
			infinite: true,
			arrows: false,
			fade: true,
			autoplay: true,
			autoplaySpeed: 2000,
			speed: 1000,
			pauseOnHover: false,
		});
	}



// Init
// -----------------------------------------------------------------------------

	$(document).ready(() => {
		window.history.scrollRestoration = "manual";
		windowTop = document.documentElement.scrollTop;
		windowHeight = window.innerHeight;
		initLazyLoad();
		setScrollbarWidthVariable();
		set100VHVariable();
		scrollToHash();
		toggleMenu();
		quoteSlider();
		onScroll();
		inView();
	});

	$(window).on("scroll", () => {
		windowTop = document.documentElement.scrollTop;
		windowHeight = window.innerHeight;
		onScroll();
		inView();
	});

	$(window).on("load", () => {
		windowHeight = window.innerHeight;
		updateMainScroll();
	});

	$(window).on("resize", () => {
		setScrollbarWidthVariable();
		set100VHVariable();
	});

	// Debounce helper
	function debounce(func, wait) {
		let timeout;
		return function executedFunction(...args) {
			const later = () => {
				clearTimeout(timeout);
				func(...args);
			};
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
		};
	}

	const resizeObserver = new ResizeObserver(
		debounce(() => {
			updateMainScroll();
		}, 250)
	);

	resizeObserver.observe(document.body);

}(jQuery));
